<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M22 5H9V3H17V1H7V1.41V3V5H2V7H17.98L16.23 21H7.76001L6.26001 9H4.25L6 23H18L20 7H22V5Z" />
</svg>
